import { Component, OnInit, ViewChild, ViewEncapsulation, output, ChangeDetectionStrategy } from '@angular/core';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { map, startWith, take} from 'rxjs/operators';
import { Property } from '../../models/property';
import { PropertyService } from '../../services/PropertyService';
import { AppService } from '../../app.service';
import { SearchCategory, SearchItem, SearchResult } from '../../models/searchResult';
import { PropertyFilterParameters, PropertySearch } from '../../models/propertyFilterParameters';

@Component({ standalone: false,
  selector: 'app-properties-search-box',
  templateUrl: './properties-search-box.component.html',
  styleUrls: ['./properties-search-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})
export class PropertiesSearchHomeComponent implements OnInit {
  @ViewChild(MatAutocompleteTrigger, {read: MatAutocompleteTrigger}) inputAutoComplete?: MatAutocompleteTrigger;
  readonly searchItemSelected = output<PropertyFilterParameters>();

  public showMore: boolean = false;
  public searchForm: FormGroup;
  public currentSearchResult?: SearchResult;

  private sub?:Subscription;

  constructor(private propertyService:PropertyService, private appService:AppService) { 
     this.searchForm = new FormGroup({
      searchString: new FormControl<string|undefined>(undefined)
    }); 
  }

  ngOnInit() {
    //hook up auto complete filter
    this.sub = this.searchForm.get('searchString')!.valueChanges
    .pipe(
      startWith(''),
      map((value:string) => {
        this.propertyService.getProperties().pipe(take(1)).subscribe(pa=>{
          this.filter(value,pa);
        });
      })
    ).subscribe();
  }

  ngOnDestroy(){
    this.sub?.unsubscribe();
  }

  private filter(value: string, propertyArray:Property[]){
    this.currentSearchResult = this.appService.searchPropertyData(propertyArray,value);
  }

  get searchCategories(): SearchCategory[] {
    return this.currentSearchResult?.categories ?? [];
  }

  public reset(){     
    this.searchForm.reset();
    this.currentSearchResult=undefined;
  }

  public onInputFieldClick($event:any){
    $event.stopPropagation();
    this.inputAutoComplete?.openPanel();
  }

  public onItemSelected(searchItem:SearchItem, trigger: MatAutocompleteTrigger, auto: MatAutocomplete){
    //identify what searchItem has been selected and collect relevant propertyIds
    var propertyIdList:number[]=[];
    var pfp:PropertyFilterParameters=new PropertyFilterParameters();
    setTimeout(() => {
      auto.options.forEach((item) => {
        item.deselect()
      });
    }, 100);
    if(searchItem.resultType=="state"){
      pfp.propertySearch=new PropertySearch(searchItem.resultDescription,searchItem.propertyIds);
    }
    else if(searchItem.resultType=="county"){
      pfp.propertySearch=new PropertySearch(searchItem.resultDescription,searchItem.propertyIds);
    }
    else if(searchItem.resultType=="city"){
      pfp.propertySearch=new PropertySearch(searchItem.resultDescription,searchItem.propertyIds);

    }
    else if(searchItem.resultType=="address"){
      pfp.propertySearch=new PropertySearch(searchItem.resultDescription,searchItem.propertyIds);
      pfp.propertySearch.goDirect=true;
    }
    else if(searchItem.resultType=="text"){
      //text search
      this.propertyService.getProperties().pipe(take(1)).subscribe(pa=>{
        pa.forEach(p=>{
          if(p.searchData.includes(searchItem.result)){
            propertyIdList.push(p.id);
          }
        });
        pfp.propertySearch=new PropertySearch(searchItem.resultDescription,propertyIdList);
      });
    }
    else if(searchItem.resultType=="US"){
      this.propertyService.getProperties().pipe(take(1)).subscribe(pa=>{
        pa.forEach(p=>{
            propertyIdList.push(p.id);
        });
        pfp.propertySearch=new PropertySearch(searchItem.resultDescription,propertyIdList);
      });
    }
    this.searchItemSelected.emit(pfp);
    this.reset();
  }

  public onSearchClicked($event:any){
    //just make a text search when the spyglass was clicked
    var pfp:PropertyFilterParameters=new PropertyFilterParameters();
    let searchString = this.searchForm.get('searchString')!.value;
    if(searchString?.length>0){
      var propertyIdList:number[]=[];
      this.propertyService.getProperties().pipe(take(1)).subscribe(pa=>{
        pa.forEach(p=>{
          if(p.searchData.includes(searchString)){
            propertyIdList.push(p.id);
          }
        });
        pfp.propertySearch=new PropertySearch(searchString,propertyIdList);
        this.searchItemSelected.emit(pfp);
      });
    }
    this.inputAutoComplete?.closePanel();
    this.reset();
    $event.stopPropagation();
  }
}